import Vue from 'vue';
export default function (component, cpName) {
  var installComponent = {
    install: function install(Vue) {
      Vue.component(cpName, component);
    }
  };
  Vue.use(installComponent);
}